const tr = {
  // Navigation
  nav_logo: "CHIEF",
  nav_what_is: "Chief Nedir?",
  nav_what_does: "Ne Yapar?",
  nav_who_for: "Kimler İçin?",
  nav_talk: "Chief ile Konuş",
  nav_home: "Ana Sayfa",
  nav_partnership: "Partnerlik Modeli",

  // Hero
  hero_title_1: "Verilerinizi okuyan, sorularınızı yanıtlayan, iş akışlarını sonuçlandıran",
  hero_title_2: "yapay zeka asistanı",
  hero_desc: "Chief; CRM, ERP, Excel, SQL ve veri kaynaklarındaki veriyi anında okur. WhatsApp, Telegram veya özel chatbot üzerinden sorularınızı yanıtlar; değişiklikleri izler, uyarılar üretir ve iş akışlarını otomatik olarak başlatır. Chief, sizin için tüm süreci planlar, takip eder ve sonuçlandırır.",
  hero_cta: "Chief ile Konuş",

  // How it works
  how_title_1: "Chief",
  how_title_2: "nasıl çalışır?",
  how_desc: "Veri kaynaklarınızdan iş akışına giden yolu, yapay zeka iş asistanı Chief yönetir.",
  how_footer: "Excel'den ERP'ye, tüm veriniz Chief'in elinin altında",

  // Data Sources
  data_crm: "CRM",
  data_erp: "ERP",
  data_excel: "Excel",
  data_sql: "SQL",
  data_memory: "Kurumsal Hafıza",

  // Outputs
  output_qa: "Soru - Cevap",
  output_notification: "Bildirim - Uyarı",
  output_action: "Eylem Tetikleme",

  // Workflow
  workflow_title: "İş akışını yöneten yapay zeka asistanı",
  workflow_desc_1: "Chief yalnızca analiz eden bir sistem değildir.",
  workflow_desc_2: "Soru sorarsınız, cevabı alırsınız; süreçler otomatik ilerler.",
  workflow_desc_3: "Doğru görevler, doğru kişilere, doğru zamanda gider.",
  workflow_desc_4: "Ekipler beklemeden çalışır; operasyon aksamaz.",
  workflow_footer: "Chief, iş akışına göre tüm görevleri otomatik olarak doğru kişiye yönlendirir.",

  // Advantages
  advantage_time_title: "Zaman Kazandırır",
  advantage_time_desc: "Manuel takip yükünü ortadan kaldırır. İş akışları kendiliğinden ilerler. Raporlama ve onay süreçleri önemli ölçüde kısalır.",
  advantage_error_title: "Hatasız Süreçler",
  advantage_error_desc: "Veri giriş hatalarını engeller. Her ekip aynı doğrulukta ve güncel bilgiyle çalışır.",
  advantage_transparent_title: "Şeffaf Operasyon",
  advantage_transparent_desc: "Her görev, her onay ve her rapor izlenebilir. Yönetim ve ekipler her zaman güncel bilgiye ulaşır.",

  // Teams
  teams_title: "Chief, tüm ekipler için gerçek bir asistan",
  teams_desc: "Her rolün ihtiyacını bilir. İş akışını doğru birime ve doğru kişiye yönlendirir. Chief tüm iş akışını arka planda otomatik yönetir, süreçler aksamadan sonuçlanır.",

  // Roles
  role_clevel_title: "Stratejik Kontrol",
  role_clevel_desc: "KPI'lere anında ulaşır, raporları beklemezsiniz. Risk ve kârlılık kararları gerçek zamanlı verilerle alınır.",
  role_manager_title: "Takım Performansı Kontrolü",
  role_manager_desc: "Ekip iş yükünü dengeler, gecikmeleri önler. Onay süreçleri otomatik akar.",
  role_operation_title: "Kesintisiz Süreç Yönetimi",
  role_operation_desc: "Görevler doğru ekipte, doğru sırada akışa girer. Sahadan merkeze iletişim kusursuz çalışır.",
  role_sales_title: "Daha Fazla Teklif, Daha Fazla Kazanç",
  role_sales_desc: "Satış ekiplerine otomatik görevler. Teklifler zamanında oluşturulur ve takip edilir.",
  role_marketing_title: "Kampanyalar Operasyona Bağlanır",
  role_marketing_desc: "Segmentasyon, içgörü ve müşteri aksiyonları tek bir yapay zekâ hafızasında birleşir.",
  role_support_title: "Daha Hızlı Çözüm",
  role_support_desc: "Şikâyetler ve talepler iş birimlerine görev olarak akar. Memnuniyet artar, kayıp müşteriler azalır.",

  animation_title: "Chief görevleri yönlendirir, işleri sonuçlandırır.",

  role_ceo: "CEO",
  role_cfo: "CFO",
  role_coo: "COO",
  role_cmo: "CMO",
  role_sales: "Satış",
  role_field: "Saha Denetimi",
  role_production: "Üretim",
  role_quality: "Kalite",

  // Task Animation Texts
  task_1_title: "Teklif Görevi Oluşturuldu",
  task_1_subtitle: "Müşteri teslimatı bekleniyor",
  task_2_title: "Bütçe Onay Talebi",
  task_2_subtitle: "Ön onay akışına alındı",
  task_3_title: "Operasyon Görevi Planlandı",
  task_3_subtitle: "Kaynaklar atanıyor",
  task_4_title: "İş Emri Çıkarıldı",
  task_4_subtitle: "Hat yöneticisine bildirim gönderildi",
  task_5_title: "Kalite Kontrol Başlatıldı",
  task_5_subtitle: "Numune analizi açıldı",
  task_6_title: "Saha Görevi Atandı",
  task_6_subtitle: "Konum bilgisi paylaşıldı",
  task_7_title: "Kampanya Brifingi Paylaşıldı",
  task_7_subtitle: "İçerik üretimine başlandı",
  task_8_title: "Haftalık Performans Raporu Hazır",
  task_8_subtitle: "Sunum onayına iletildi",

  // Partnership
  partner_section_title: "Chief ile iş ortağı olun",
  partner_section_desc: "Chief'i kendi çözümlerinizle birlikte konumlandırın, müşterilerinize yapay zeka destekli karar asistanı sunun. Gelir paylaşımı, entegrasyon desteği ve ortak pazarlama ile birlikte büyüyün.",
  partner_tech_title: "Teknoloji & entegrasyon partnerleri",
  partner_tech_desc: "ERP, CRM, BI ve özel yazılımlarınıza Chief'i entegre ederek müşterilerinize uçtan uca karar destek çözümü sunabilirsiniz.",
  partner_consulting_title: "Danışmanlık & dijital dönüşüm firmaları",
  partner_consulting_desc: "Süreç analizi, veri projesi veya dijital dönüşüm danışmanlığı yaparken Chief'i standart araç setinizin bir parçası olarak konumlandırın.",
  partner_saas_title: "SaaS & ürün sahipleri",
  partner_saas_desc: "Mevcut ürünlerinize yapay zeka katmanı ekleyin. Chief, veri okuma, soru–cevap ve aksiyon tetikleme yetenekleriyle ürünü daha akıllı hale getirir.",
  partner_cta_desc: "Partnerlik modeli ve detaylar için özel sayfayı inceleyin.",
  partner_cta_button: "Partnerlik Modeli",

  // Footer
  footer_desc: "Chief, Datafors tarafından geliştirilen yapay zeka iş asistanıdır. Kurumunuzdaki veriyi okur, iş akışlarını otomatikleştirir, ekiplerin daha hızlı ve hatasız çalışmasını sağlar.",
  footer_links_title: "Bağlantılar",
  footer_link_what: "Chief Nedir?",
  footer_link_what_does: "Ne Yapar?",
  footer_link_who: "Kimler İçin?",
  footer_link_partnership: "Partnerlik Modeli",
  footer_link_faq: "Sık Sorulan Sorular",
  footer_contact_title: "İletişim",
  footer_email: "Email: talktochief@chiefai.com.tr",
  footer_phone: "Tel: +90 216 606 22 09",
  footer_office: "Ofis: Boğaziçi Üniversitesi Kandilli Teknopark İstanbul · Türkiye",
  footer_faq: "Sık Sorulan Sorular",
  footer_privacy: "Gizlilik Politikası",
  footer_terms: "Kullanım Şartları",
  footer_cookies: "Çerez Politikası",
  footer_copyright: "© 2025 Datafors. Tüm hakları saklıdır.",
  footer_powered: "Powered by DataFors",

  // Partnership Pages
  partnership_hero_title_1: "Chief ile",
  partnership_hero_title_2: "İş Ortağı Olun",
  partnership_hero_desc: "Chief'i kendi çözümlerinizle birlikte konumlandırın, müşterilerinize yapay zeka destekli karar asistanı sunun. Gelir paylaşımı, entegrasyon desteği ve ortak pazarlama ile birlikte büyüyün.",
  partnership_models_title: "Partnerlik Modelleri",
  partnership_models_desc: "İş modelinize uygun partnerlik türünü seçin ve Chief ekosisteminin bir parçası olun.",
  partnership_tech_title: "Teknoloji & Entegrasyon Partnerleri",
  partnership_tech_desc: "ERP, CRM, BI ve özel yazılımlarınıza Chief'i entegre ederek müşterilerinize uçtan uca karar destek çözümü sunabilirsiniz.",
  partnership_tech_feature_1: "API ve webhook entegrasyonu",
  partnership_tech_feature_2: "Teknik dokümantasyon desteği",
  partnership_tech_feature_3: "Ortak müşteri başarı yönetimi",
  partnership_tech_feature_4: "Gelir paylaşımı modeli",
  partnership_consulting_title: "Danışmanlık & Dijital Dönüşüm",
  partnership_consulting_desc: "Süreç analizi, veri projesi veya dijital dönüşüm danışmanlığı yaparken Chief'i standart araç setinizin bir parçası olarak konumlandırın.",
  partnership_consulting_feature_1: "Proje bazlı lisanslama",
  partnership_consulting_feature_2: "Eğitim ve sertifikasyon programı",
  partnership_consulting_feature_3: "Satış öncesi teknik destek",
  partnership_consulting_feature_4: "Ortak pazarlama fırsatları",
  partnership_saas_title: "SaaS & Ürün Sahipleri",
  partnership_saas_desc: "Mevcut ürünlerinize yapay zeka katmanı ekleyin. Chief, veri okuma, soru–cevap ve aksiyon tetikleme yetenekleriyle ürünü daha akıllı hale getirir.",
  partnership_saas_feature_1: "White-label çözüm seçenekleri",
  partnership_saas_feature_2: "Embedded entegrasyon",
  partnership_saas_feature_3: "Müşteri başına fiyatlandırma",
  partnership_saas_feature_4: "Teknik entegrasyon desteği",
  partnership_benefits_title: "Partnerlik Avantajları",
  partnership_benefits_desc: "Chief partneri olarak kazanacağınız değerler ve fırsatlar.",
  benefit_revenue_title: "Gelir Paylaşımı",
  benefit_revenue_desc: "Rekabetçi komisyon oranları ve sürdürülebilir gelir modeli",
  benefit_support_title: "Teknik Destek",
  benefit_support_desc: "Entegrasyon ve satış öncesi teknik destek ekibi",
  benefit_marketing_title: "Ortak Pazarlama",
  benefit_marketing_desc: "Co-marketing kampanyaları ve içerik üretimi",
  benefit_training_title: "Eğitim Programı",
  benefit_training_desc: "Sertifikasyon ve sürekli eğitim imkanları",
  benefit_access_title: "Öncelikli Erişim",
  benefit_access_desc: "Yeni özelliklere erken erişim ve beta testleri",
  benefit_community_title: "Partner Topluluğu",
  benefit_community_desc: "Diğer partnerlerle networking ve bilgi paylaşımı",
  benefit_materials_title: "Satış Materyalleri",
  benefit_materials_desc: "Hazır sunum, demo ve satış dokümanları",
  benefit_analytics_title: "Performans Takibi",
  benefit_analytics_desc: "Detaylı raporlama ve analiz araçları",
  partnership_process_title: "Nasıl Partner Olunur?",
  partnership_process_desc: "Basit ve hızlı başvuru süreci ile Chief ekosisteminin bir parçası olun.",
  process_step_1_title: "Başvuru",
  process_step_1_desc: "Formu doldurun veya bizimle iletişime geçin",
  process_step_2_title: "Değerlendirme",
  process_step_2_desc: "Ekibimiz başvurunuzu 2-3 iş günü içinde inceler",
  process_step_3_title: "Onboarding",
  process_step_3_desc: "Eğitim ve entegrasyon sürecini tamamlayın",
  process_step_4_title: "Başlayın",
  process_step_4_desc: "Müşterilerinize Chief'i sunmaya başlayın",
  partnership_cta_title: "Hemen Başlayın",
  partnership_cta_desc: "Chief ile iş ortaklığı kurmak ve müşterilerinize yapay zeka destekli çözümler sunmak için bizimle iletişime geçin.",
  partnership_cta_button: "Partnerlik Başvurusu Yap",

  // Privacy Policy
  privacy_title: "Gizlilik Politikası",
  privacy_updated: "",
  privacy_intro: "Chief, Datafors tarafından geliştirilen bir yapay zeka asistanıdır. Kullanıcılarımızın kişisel verilerinin güvenliği ve gizliliği bizim için önceliklidir. Bu Gizlilik Politikası, hizmetlerimizi kullanırken hangi verileri topladığımızı, nasıl işlediğimizi ve nasıl koruduğumuzu açıklar.",
  privacy_collected_title: "Toplanan Veriler",
  privacy_collected_desc: "Chief, hizmet kapsamında aşağıdaki veri kategorilerini işleyebilir:",
  privacy_collected_1: "Kimlik bilgileri (Ad, soyad)",
  privacy_collected_2: "İletişim bilgileri (Telefon, e-posta)",
  privacy_collected_3: "Kurum bilgileri (Çalışılan şirket, pozisyon)",
  privacy_collected_4: "Sistem verileri (Kullanılan cihaz, IP adresi, çerezler)",
  privacy_collected_5: "Operasyonel veriler (Chief üzerinden yapılan talepler, iş emirleri ve kayıtlar)",
  privacy_usage_title: "Verilerin Kullanım Amaçları",
  privacy_usage_desc: "Toplanan veriler;",
  privacy_usage_1: "Hizmet sunmak ve iş akışlarını yönetmek",
  privacy_usage_2: "Sorularınıza hızlı yanıt vermek",
  privacy_usage_3: "Ürün performansını iyileştirmek",
  privacy_usage_4: "Güvenlik ve doğrulama işlemleri",
  privacy_usage_suffix: "amaçlarıyla işlenmektedir.",
  privacy_sharing_title: "Veri Paylaşımı",
  privacy_sharing_desc: "Verileriniz aşağıdaki durumlar dışında üçüncü kişilerle paylaşılmaz:",
  privacy_sharing_1: "Yasal yükümlülükler",
  privacy_sharing_2: "Kullanıcı onayı ile entegrasyon yapılan sistemler",
  privacy_sharing_3: "Hizmet sağlayıcı altyapı firmaları (örn: sunucu servisleri)",
  privacy_security_title: "Veri Güvenliği",
  privacy_security_desc: "Verileriniz,",
  privacy_security_1: "Şifrelenmiş veri tabanlarında",
  privacy_security_2: "Yetki kontrollü erişim yapılarıyla",
  privacy_security_suffix: "saklanır.",
  privacy_retention_title: "Veri Saklama Süresi",
  privacy_retention_desc: "Verileriniz, hizmet ilişkisinin devam ettiği süre boyunca veya yasal düzenlemelerin öngördüğü süre boyunca saklanır.",
  privacy_rights_title: "Haklarınız",
  privacy_rights_desc: "KVKK ve GDPR kapsamında;",
  privacy_rights_1: "Verilerinize erişme,",
  privacy_rights_2: "Düzeltilmesini isteme,",
  privacy_rights_3: "Silinmesini veya taşınmasını talep etme,",
  privacy_rights_4: "İşlemeye itiraz etme",
  privacy_rights_suffix: "haklarına sahipsiniz.",
  privacy_contact_title: "İletişim",
  privacy_contact_desc: "Sorularınız için: privacy@datafors.com",

  // Terms of Use
  terms_title: "Kullanım Şartları",
  terms_updated: "Son güncelleme: Ocak 2025",
  terms_intro: "Chief'i kullanarak aşağıdaki şartları kabul etmiş sayılırsınız.",
  terms_service_title: "Hizmet Kapsamı",
  terms_service_desc: "Chief, kullanıcılarının veriye erişimini kolaylaştıran ve iş akışlarını yöneten bir yapay zeka asistanıdır. İş süreçlerine dair öneri ve aksiyonlar üretir; ancak nihai karar ve kontrol kullanıcıya aittir.",
  terms_obligations_title: "Kullanıcı Yükümlülükleri",
  terms_obligations_1: "Hesap güvenliğini korumaktan kullanıcı sorumludur.",
  terms_obligations_2: "Hukuka aykırı, zararlı veya yanıltıcı taleplerde bulunulamaz.",
  terms_obligations_3: "Sistemdeki verilerin doğruluğunu kullanıcı sağlar.",
  terms_ip_title: "Fikri Mülkiyet",
  terms_ip_desc: "Chief'e ait tüm tasarım, kod, model ve görseller Datafors mülkiyetindedir. İzinsiz kopyalanamaz, çoğaltılamaz.",
  terms_access_title: "Erişim ve Değişiklikler",
  terms_access_desc: "Datafors, hizmeti geliştirme, durdurma veya erişimi sınırlama hakkını saklı tutar.",
  terms_liability_title: "Sorumluluk Reddi",
  terms_liability_desc: "Chief'in önerdiği aksiyonlar tavsiye niteliğindedir. Ticari, hukuki veya operasyonel sonuçlardan doğrudan kullanıcı sorumludur.",
  terms_effective_title: "Yürürlük",
  terms_effective_desc: "Bu şartlar yayımlandığı tarihten itibaren geçerlidir.",

  // Cookie Policy
  cookies_title: "Çerez Politikası",
  cookies_updated: "Son güncelleme: Ocak 2025",
  cookies_intro: "Chief web sitesi ve uygulaması, kullanıcı deneyimini iyileştirmek için çerezler kullanır.",
  cookies_types_title: "Kullanılan Çerez Türleri",
  cookies_types_1: "Zorunlu çerezler: Güvenlik ve oturum yönetimi",
  cookies_types_2: "Performans çerezleri: Kullanıcı deneyimini ölçümleme",
  cookies_types_3: "İşlevsel çerezler: Tercihlerin hatırlanması",
  cookies_manage_title: "Çerezleri Yönetme",
  cookies_manage_desc: "Tarayıcı ayarlarınızdan çerez kullanımını:",
  cookies_manage_1: "Kabul edebilir,",
  cookies_manage_2: "Sınırlayabilir,",
  cookies_manage_3: "Tamamen engelleyebilirsiniz.",
  cookies_manage_note: "Çerezleri kapatmanız durumunda bazı bölümler çalışmayabilir.",
  cookies_legal_title: "Hukuki Dayanak",
  cookies_legal_desc: "Çerez kullanımı, KVKK ve e-Privacy direktifleri çerçevesinde gerçekleştirilir.",

  // FAQ
  faq_title: "Sık Sorulan Sorular",
  faq_subtitle: "Chief hakkında bilmeniz gerekenler",
  faq_q1: "Chief nedir?",
  faq_a1: "Kurumunuzdaki verileri okuyan, sorularınızı cevaplayan ve iş akışlarını otomatik yöneten yapay zeka asistanıdır.",
  faq_q2: "Chief ne yapar?",
  faq_a2: "Veriyi analiz eder, iş emirlerini doğru kişiye yönlendirir, süreçleri takip eder, raporlar ve sonuçlandırır.",
  faq_q3: "Chief hangi sistemlerle çalışır?",
  faq_a3: "CRM, ERP, SQL, Excel, API ve kurumun veri kaynaklarıyla entegre olabilir.",
  faq_q4: "Chief hangi platformlarda kullanılabilir?",
  faq_a4: "Web, mobil, WhatsApp ve özel chatbot entegrasyonlarıyla kullanılabilir.",
  faq_q5: "Verilerim güvende mi?",
  faq_a5: "Evet. Veriler şifrelenmiş olarak saklanır ve yalnızca yetkili kişiler erişebilir.",
  faq_q6: "Demo alabilir miyim?",
  faq_a6: "Evet. İletişim formu veya \"Chief ile Konuş\" butonu üzerinden talep bırakabilirsiniz.",
  faq_contact_text: "Daha fazla sorunuz mu var?",
};

export default tr;
